<div class="container-fluid row_banner">
  <app-header></app-header>
  <h1 class="terms-title">Term of Services</h1>
  <div class="container terms-container">
    <div class="row row_banner_1">
      <div class="container">
        <div
          class="row py-3 mt-2 justify-content-center"
          style="align-content: justify"
        >
          <div class="plag_benefit w-100 px-3 pt-3">
            <span class="terms" style="margin-top: 50px">Term of Services</span>
            <br />
            <br />
            <p class="detail">
              At Grammarin.com, we are attentively aware of the trust you place
              in us and our foremost responsibility is to protect your privacy.
              On the behalf of this responsibility, we are sharing with you what
              information we collect when you use our website Grammarin.com for
              analyzing your text. We also explicate, why we collect it and how
              we use it to improve your experience. By using the Grammarin.com
              website, you consent to the data practices described in this
              statement
            </p>
            <br />
            <span class="terms">Use of Personal Information</span>
            <br />
            <br />
            <p class="detail">
              If you are agree with our terms of services and step forward
              towards subscribe our emails or newsletter Grammarin.com may use
              your personally identified mail address to notify you about other
              products or services assessable from Grammarin.com.
            </p>
            <p class="detail">
              <a class="aTag " href="/"> Grammarin.com  </a>may also contact you via surveys to conduct research
              about your opinion of current services or of potential new
              services. Please keep in mind that if you directly disclose
              personally identifiable information or personally sensitive data
              through the Grammarin.com blog, this information may be collected
              and used by others.
            </p>
            <p class="detail">
              Grammarin.com always prefer the privacy of their users and does
              not sell, rent or lease its customer lists to third parties.
              Grammarin.com will disclose your personal information, without
              notice, only if required to do so by law or in the good faith
              belief that such action is necessary to: (a) conform to the edicts
              of the law or comply with legal process served on Grammarin.com or
              the site; (b) protect and defend the rights or property of
              Grammarin.com (including enforcing this agreement); and, (c) act
              under exigent circumstances to protect the personal safety of
              users of Grammairin.com, or the public.
            </p>
            <br />
            <span class="terms">Information Collection</span>
            <br />
            <br />
            <p class="detail">
              All data collected by the Gammararin.com tool can be manually
              accessed by several other means publicly assessable online (Who is
              Lookup, Google Cached Pages, etc.). That is why every single
              report generated on Grammarin.com is considered ‘public’ and is
              thus stored in our database. Furthermore, it can be indexed by
              search engines. Grammarin.com collects and uses website
              information to operate its website analysis tool and deliver the
              services you have requested. This information can include: IP
              address, domain names, estimated visitors, in-site and off-site
              SEO analysis, usability, access times and referring website
              addresses. This information is used by Grammarin.com for the
              operation of its service and to provide general statistics
              regarding use of the Grammarin.com web tool.
            </p>
            <br />
            <span class="terms">Restrictions</span>
            <span class="terms"> You agree that you will not</span>
            <br />
            <br />
            <ul class="detail">
              <li>
                Distribute the content for any purpose including without
                limitation compiling an internal database, redistributing or
                reproduction of the content by the press or media or through any
                commercial network, cable or satellite system.
              </li>
              <li>
                Create imitative works of, reverse engineer, decompile,
                disassemble, adapt, translate, transmit, arrange, modify, copy,
                bundle, sell, sub-license, export, merge, transfer, adapt, loan,
                rent, lease, assign, share, outsource, host, publish, make
                available to any person or otherwise use, either directly or
                indirectly, the content/tools in whole or in part, in any form
                or by any means whatsoever, be they physical, electronic or
                otherwise.
              </li>
              <li>
                Permit, allow or do anything that would infringe or otherwise
                prejudice the proprietary rights of the Company or its
                licensor’s or allow any third-party to access the content/tools.
                The restrictions set out in this Agreement shall not apply to
                the limited extent the restrictions are prohibited applicable
                law.
              </li>
              <li>
                Use or attempt to use automated website grabbing software (also
                known as website downloader or website copier software) to save
                multiple pages from the website for any use, including offline
                viewing.
              </li>
              <li>Use bots.</li>
              <li>
                Use advertisement blocking software to prevent the loading and
                display of advertisement from the website.
              </li>
            </ul>
            <br />
            <span class="terms">Disclaimer</span>
            <br />
            <br />
            <p class="detail">
              Without Professional advice, the tools provided by Grammarin.com
              is not intended for use for any applications.
            </p>
            <p class="detail">
              Further, the information contained herein is intended to afford
              general guidelines on matters of common interest. Sightseers are
              encouraged to consult with SEO experts for advice concerning
              specific matters before making any decision, and Grammarin.com
              disclaims any responsibility for positions taken by the tools
              provided by Grammarin.com or for any misunderstanding on the part
              of Grammarin.com
            </p>
            <span class="terms">Security of your Personal Information</span>
            <br />
            <br />
            <p class="detail">
              No tactic of safeguarding information is 100% secure.
              Grammarin.com uses a variety of security technologies and
              procedures to help protect your personal information from
              unauthorized access, use or disclosure. Grammarin.com secures the
              personally identifiable information you provide on computer
              servers in a controlled, secure environment, protected from
              unauthorized access, use or disclosure. When personal information
              (such as a credit card number) is transmitted to other websites,
              it is protected through the use of encryption, such as the Secure
              Socket Layer (SSL) protocol.
            </p>
            <br />
            <span class="terms">Changes to this Statement</span>
            <br />
            <br />
            <p class="detail">
              Grammarin.com will sporadically update this Terms of Service to
              reflect company and customer feedback. Grammarin.com uplift you to
              regularly review this Terms of Service to be informed of how
              Grammarin.com is protecting your information. When such a change
              is made, we will update the “Last Updated” date below. Use of this
              Grammarin.com website indicates your affirmation of these Terms of
              Service.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<a
  (click)="scrollToTop()"
  *ngIf="shouldShowButton"
  id="scroll-to-top"
  data-tooltip="Go to top"
>
  <app-icons-free-tools name="goToTopIcon" />
</a>
<app-footer></app-footer>
